import { getProposedDates } from '@/api/interviews';
import { useApiQuery } from '@/hooks/api';
import { REFERENCE_STALE_TIME } from '@/hooks/api/defaults';
import { queryKeys } from '@/shared/lib/queryKeys';

import type { ProposedDatesResponse } from '@/types/interview';

export function useProposedDatesQuery(
  interviewId: string | undefined,
  options?: { enabled?: boolean },
) {
  const { enabled = true } = options ?? {};

  return useApiQuery<ProposedDatesResponse | null | undefined>({
    queryKey: queryKeys.interviews.proposedDates(interviewId ?? ''),
    queryFn: () => getProposedDates(interviewId!) ?? Promise.resolve(undefined),
    enabled: enabled && Boolean(interviewId),
    staleTime: REFERENCE_STALE_TIME,
  });
}
